import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { longFormatDate, shortFormatDate } from '@liveauctioneers/caterwaul-components/lib/utils/dates';
import { TimedPlusStatus } from '../TimedPlusCountdown/types/TimedPlusStatus.enum';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled, { useTheme } from 'styled-components';
import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';
import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';

export type TimedPlusStartDateProps = {
    saleStartTimestamp: number;
};

const TimedPlusStartDate = ({ saleStartTimestamp }: TimedPlusStartDateProps) => {
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();
    const isMobile = useIsNarrowerThan(tabletNarrowWidthNum + 1);
    const formattedDate = isMobile ? shortFormatDate(saleStartTimestamp) : longFormatDate(saleStartTimestamp);

    return (
        <StyledTimedPlusStartDate>
            <FormattedMessage
                id={`itemPage.biddingInfo.timedPlus.${
                    TimedPlusStatus.NotStarted
                }.starts${isMobile ? 'Mobile' : 'Desktop'}`}
                values={{
                    info: (
                        <Tooltip
                            placement="bottom-end"
                            trigger={
                                <Info
                                    color="primary"
                                    size="sm"
                                    style="fill"
                                />
                            }
                        >
                            <FormattedMessage
                                id="itemPage.biddingInfo.timedPlus.timedPlusDescription"
                                values={{
                                    helpLink: (
                                        <Link
                                            key="timed-plus-start-date-help-link"
                                            target="_blank"
                                            to="https://support.liveauctioneers.com/hc/en-gb/articles/24574071591313-How-do-Timed-auctions-work"
                                        >
                                            <FormattedMessage id="itemPage.biddingInfo.timedPlus.helpLinkText" />
                                        </Link>
                                    ),
                                }}
                            />
                        </Tooltip>
                    ),
                    startDate: formattedDate,
                }}
            />
        </StyledTimedPlusStartDate>
    );
};

export default TimedPlusStartDate;

const StyledTimedPlusStartDate = styled(BodySecondary)`
    display: flex;
    & > [data-testid='popover'] {
        margin-left: 6px;
    }
`;
